module.exports = __webpack_public_path__ + "img/application_icon_more@2x.d0352be9.png";